import React, { Component } from "react";
import { Link } from "react-router-dom";
import { Swiper, SwiperSlide } from "swiper/react";
import { Navigation, Autoplay } from "swiper/modules";

class Categories extends Component {
  render() {
   
    return (
      <div className="categories">
        <span className="title">دسته بندی محصولات</span>
        <div className="categoriesSection">
          <div className={"categoryItems"}>
            <div>
              <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                spaceBetween={12}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
              >
                {this.props.data
                  .slice(0, this.props.data.length / 3)
                  .map((category) => (
                    <SwiperSlide key={category.id}>
                      <Link
                        to={`/categories/${category.id}`}
                        className="categorie"
                      >
                        <img alt="category" src={category.image} />
                        <span>{category.name}</span>
                      </Link>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
            <div>
              {" "}
              <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                spaceBetween={12}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
              >
                {this.props.data
                  .slice(
                    this.props.data.length / 3,
                    (this.props.data.length / 3) * 2
                  )
                  .map((category) => (
                    <SwiperSlide key={category.id}>
                      <Link
                        to={`/categories/${category.id}`}
                        className="categorie"
                      >
                        <img alt="category" src={category.image} />
                        <span>{category.name}</span>
                      </Link>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
            <div>
              <Swiper
                modules={[Autoplay]}
                slidesPerView={3}
                spaceBetween={12}
                loop={true}
                autoplay={{
                  delay: 2500,
                  disableOnInteraction: false,
                }}
              >
                {this.props.data
                  .slice((this.props.data.length / 3) * 2)
                  .map((category) => (
                    <SwiperSlide key={category.id}>
                      <Link
                        to={`/categories/${category.id}`}
                        className="categorie"
                      >
                        <img alt="category" src={category.image} />
                        <span>{category.name}</span>
                      </Link>
                    </SwiperSlide>
                  ))}
              </Swiper>
            </div>
          </div>
        </div>
      </div>
    );
  }
}
export default Categories;
